export const API_PROJECTS_PATH = 'projects/list';

export const IMAGE_DIR = '/images';
